// extracted by mini-css-extract-plugin
export default {"app":"App_app__6Ra7L","title":"App_title__zQTwp","controls":"App_controls__11teL"};